export const multiWordSearch = (data, searchTerm, fieldsExtractor) => {
    if (!searchTerm) return data;
  
    const words = searchTerm.toLowerCase().trim().split(/\s+/);
  
    return data.filter(item => {
      const searchableValues = fieldsExtractor(item)
        .filter(Boolean)
        .map(val => String(val).toLowerCase());
  
      return words.every(word =>
        searchableValues.some(value =>
          value.includes(word)
        )
      );
    });
  };
  